export const MODAL_NAMES = {
  RESET_PASSWORD_EXPLANATION: 'RESET_PASSWORD_EXPLANATION',
}
